import ImportDetailsStore from './ImportDetailsStore'

export default ImportDetailsStore
